<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="dialogPago.visible" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">{{dialogPago.titulo}}</v-card-title>
          <v-card-text>{{dialogPago.mensaje}} <v-icon color="#008230">{{dialogPago.icon}}</v-icon></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="closeDialogo()">Entendido</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "DialogMensaje",
  computed: {
    ...mapState(["dialogPago"])
  },
  watch: {
    'dialogPago.visible'() {
      var chat = document.getElementById('calixta-badge');
      chat.style.display = (chat.style.display == 'block') ? 'none' : 'block';
    }
  },
  methods: {
    closeDialogo() {
      var r = { visible: false };
      this.$store.commit("setContenidoDialogPago", r);
    }
  }
};
</script>

<style>
</style>